import { BadgeV3 } from '@cimplico/components';
import { CustomWorksheetTemplateStatus } from '../../types/custom-worksheet-v2';

type CWTStatusBadgeProps = {
    status: CustomWorksheetTemplateStatus;
};

function CWTStatusBadge({ status }: CWTStatusBadgeProps): JSX.Element {
    switch (status) {
        case 'UNPUBLISHED':
            return <BadgeV3 label="Unpublished" color="gray" />;
        case 'PUBLISHED':
            return <BadgeV3 label="Published" color="green" />;
        case 'ARCHIVED':
            return <BadgeV3 label="Archived" color="red" />;
        default:
            return <></>;
    }
}

export default CWTStatusBadge;
